import styled from "styled-components";
import { BaseButton, colors, Switch as DefaultSwitch, types } from "../../../../../libs";
import { SpinnerWrapper } from "../../../../../libs/common/loader/Loader";
import { Spinner } from "react-bootstrap";

export const FormMainWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center; 
`;
export const FormWrapper = styled.div`
  width: 553px;
  height: 664px;
  display: flex;
  flex-direction: column;
  gap: 15px; 
`;

export const FormTitle = styled.h2`
 ${types.body.secondaryTitle};
  color: ${colors.text.white};
   margin-bottom: 10px; 
`;

export const AdVideoTitle = styled.h3`
   ${types.headers.small};
  color: ${colors.text.white};
  margin-bottom: 24px;
  margin-top: 40px;
`;

export const SectionTitle = styled.h3`
   ${types.headers.small};
  color: ${colors.text.white};
   margin-bottom: 8px;
   
`;

export const SectionCustomSelect = styled.div`
    margin-top: 24px;
    cursor: pointer;
`;

export const SubTitle = styled.p`
   ${types.body.normal}
  color: ${colors.text.gray}
  margin-bottom:0px;

`;

export const FormFieldRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 10px;
  position:sticky;
  bottom: 0px;
  background-color:${colors.background.black};
  padding-bottom:5px;
`;

export const DragDropWrapper = styled.div`
  margin-bottom: 40px;
`;

export const TransparentButton = styled(BaseButton)`
  width: 290px;
  height: 40px;
  background-color: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4); 
  color: ${colors.text.white};
`;


export const SaveCampaignButton = styled(BaseButton) <{ disabled: boolean }>`
  height: 40px;
  background-color: ${(props) => (props.disabled ? "#888888" : "")}; 
  color: ${(props) => (props.disabled ? "#B0B0B0" : "")}; 
  border: none;
`;

export const VisibilityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 35px;
`;

export const VisibilityTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;


export const LoaderWrapper = styled.div`
  position: absolute;
  top: 76px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
`;

export const CustomSpinnerWrapper = styled(SpinnerWrapper)`
  color: rgb(183, 248, 77);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const selectStyles = {
  menu: (baseStyles) => ({
    ...baseStyles,
    background: colors.background.formField,
    borderColor: "transparent",
    color: colors.text.white,
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    background: state.isFocused ? "#ccc" : colors.background.formField,
    color: state.isSelected ? colors.text.white : state.isFocused ? colors.background.formField : colors.text.white,
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: "50px",
    background: colors.background.formField,
    color: colors.text.white,
    border: state.isFocused ? "1px solid transparent" : "1px solid transparent",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: colors.background.grey,
    color: colors.text.white
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.white
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: colors.text.gray,
    fontSize: "16px",
  }),
};

export const CustomSwitch = styled(DefaultSwitch)`
  .form-check-input {
    height: 24px; 
  }
`;

export const LoadingSpinner = styled(Spinner)`
    margin-right: 10px;
`;

export const ErrorText = styled.div`
  color: ${colors.text.red};
  font-size: 15.6px;
  margin-top: 5px;
`;